import { pdfjs } from "react-pdf";

// Point pdfjs at a matching worker so react-pdf can render pages.
// Version must match the pdfjs-dist we pinned in package.json (3.11.174).
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
